import $ from 'jquery';

const numberInput = {

    init() {
        this.$input = $('[data-js-form="number"]');
        this.$upArrow = $('[data-js-form="number-up"]');
        this.$downArrow = $('[data-js-form="number-down"]');

        this.eventHandlers();
    },

    eventHandlers() {
        this.$upArrow.on('click',this.incrementUp.bind(this));
        this.$downArrow.on('click',this.incrementDown.bind(this));
    },

    incrementUp() {
        this.$input[0].value++
    },

    incrementDown() {
        this.$input[0].value--
    }
}

$(document).ready(()=>{
    numberInput.init();
})